import axios from 'axios';

export const generateCartId = (data) => {
  return axios.post('/opc/cartId/generate', data);
};

/**
 *
 * @typedef {Object} Params
 * @property {String} firstName user first name
 * @property {String} userEmail user email
 * @property {String} shortUrl /buy?cartId=${}
 * @property {Number} templateType 1 = pro only, 2 = biz only, 3 = multiple plans
 * @property {Array} zcids
 * templateType is 1, zcids = [3920, 5436]
 * templateType is 2, zcids = [3919, 5435]
 * templateType is 3, zcids = [3921, 5437]
 * @property {Array} cartItem
 * ['(${number}) ${displayName} ${participants ? (' for ' + participants + ' Participants') : ''} + ' - ' + G.translate(plan.viewInfo.billing_cycle)]
 * @property {Number} version 0 = legacy template (default), 1 = OPC template
 * @property {Array} selectedPlans
 * [{ icon: '', title: '', subtitle: '' }]
 * @param {Params} data
 * @returns
 */
export const abandonmentReminder = (data) => {
  return axios.post('/opc/email/abandon_cart/schedule', data);
};

export const cancelEmailSchedule = (scheduledId) => axios.get(`/opc/email/remove/${scheduledId}`);

/**
 *
 * @returns interface CartInfoRes {
 *  link: string;
 *  planCount: number;
 *  persist: {
 *    [planCode: string]: number,
 *  }
 * }
 */
export const getCartRequest = () => {
  return axios.get("/buy/cart/get", {
    params: {
      mktId: window.zmGlobalMrktId,
      _: Date.now()
    },
  });
};

export const setCartRequest = (cartInfo) => {
  const data = {
    cartInfo,
    mktId: window.zmGlobalMrktId,
  };

  return axios.post("/buy/cart", data);
};

export const deleteCartRequest = () => {
  return axios.delete("/buy/cart", {
    params: {
      mktId: window.zmGlobalMrktId,
    },
  });
};
